import { FilterChoice } from '../../common/components/SearchHeader/types/FilterChoice';
import { useRouter } from '../../common/hooks/useRouter';
import { useMobile } from '../../common/services/screenSize/ScreenSizeService';
import {
  DentalSidebarFilter,
  GPSidebarFilter,
} from '../ResultView/Sidebar/SidebarFilters/SidebarFilters';
import { useSeoContent } from '../page-seo/SeoContentProvider';
import { AutoDisclosure } from '../page-seo/SeoScenarios/Disclosure/Disclosure';
import { FooterBackground, StyledFeedbackFooterSection, TextSection } from './SearchFooter.styles';
import { MetroSuburbLinks } from './SuburbLinks/MetroSuburbLinks';
import { NationwideSuburbLinks } from './SuburbLinks/NationwideSuburbLinks';
import { NearbySuburbLinks } from './SuburbLinks/NearbySuburbLinks';
import { StateSuburbLinks } from './SuburbLinks/StateSuburbLinks';
import { TopicInfoLinks } from './TopicInfoLinks';
import { ConditionPresetLinks } from './preset-links/ConditionPresetLinks';
import { DentalCareInformation } from './preset-links/DentalCareInformation';
import { SpecialistPresetLinks } from './preset-links/SpecialistPresetLinks';
import { TreatmentPresetLinks } from './preset-links/TreatmentPresetLinks';

interface Props {
  filters: FilterChoice;
}

export const SearchFooter = ({ filters }: Props) => {
  const { location, text, topic } = filters;
  const suburb = location?.suburb;
  const metro = location?.metro;
  const state = location?.state;
  const seoContent = useSeoContent();

  const textContent = (!text && seoContent?.textContent) ?? '';

  const mobile = useMobile();

  const router = useRouter();

  const isFindDentist = router?.asPath.includes('/appointments/dentist');
  const isFindGP = router?.asPath.includes('/appointments/doctor');

  const footerFilters = (
    <>
      {topic && <TopicInfoLinks topic={topic} />}
      {suburb && <NearbySuburbLinks suburb={suburb} filters={filters} />}
      {metro && <MetroSuburbLinks metro={metro} filters={filters} />}
      {state && <StateSuburbLinks state={state} filters={filters} />}
      {!location && <NationwideSuburbLinks filters={filters} />}

      <TreatmentPresetLinks filters={filters} />
      <ConditionPresetLinks filters={filters} />
      <DentalCareInformation filters={filters} />
      <SpecialistPresetLinks filters={filters} />
    </>
  );

  const footerBackground = (
    <>
      <FooterBackground>
        {mobile && <StyledFeedbackFooterSection />}
        {textContent && (
          <TextSection>
            <AutoDisclosure>{textContent}</AutoDisclosure>
          </TextSection>
        )}

        {!isFindDentist && !isFindGP && footerFilters}
      </FooterBackground>
      {mobile && isFindDentist && <DentalSidebarFilter />}
      {mobile && isFindGP && <GPSidebarFilter />}
    </>
  );

  return footerBackground;
};
